/*
 * 获取N天后的时间字符
 * @param {Object} ld
 */
window.getLastTime = function(ld) {
	var times = new Date().getTime();
	var daytimes = 1000 * 60 * 60 * 24;
	var _date = new Date((times - daytimes * ld));
	var y = _date.getFullYear();
	var m = _date.getMonth() + 1;
	m = (m < 10 ? "0" + m : m);
	var d = _date.getDate();
	d = (d < 10 ? "0" + d : d)
	var _time = y + "-" + m + "-" + d;
	return _time;
}
/**
 * 获取上个月
 * @param {Object} m
 */
window.getLastMonth = function(){
	var d = new Date();
	d.setDate(0);
    return  d.getFullYear() +"-"+(d.getMonth() + 1)+"-01" + " - " +  d.getFullYear() +"-"+(d.getMonth() + 1)+"-"+d.getDate();
}

/**
 * @ 获取两个日期之间的所有日期
 *
 */
window.durationList = function(start,end) {
	if(typeof(start)=="object") {
		start = start.format('yyyy-MM-dd')
	}
	if(typeof(end)=="object") {
		end = end.format('yyyy-MM-dd')
	}
	let dateList = [];
	var startTime = getDate(start);
    var endTime = getDate(end);
    while((endTime.getTime()-startTime.getTime())>=0) {
	    var year = startTime.getFullYear();
	    var month = startTime.getMonth() + 1 < 10 ? '0'
	    + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
	    var day = startTime.getDate().toString().length == 1 ?
	    "0" + startTime.getDate() : startTime.getDate();
		dateList.push(year + "-" + month + "-" + day)
		 startTime.setDate(startTime.getDate() + 1);
    }
	return dateList
}
function getDate(datestr) {
    var temp = datestr.split("-");
    var date = new Date(temp[0], temp[1] - 1, temp[2]);
    return date;
}

/**
 * 折扣数值判断
 *
 */
window.discountBool = function(num) {
	let obj = {
		bool: true,
		cont: '请输入30-250之间的整数'
	}
	if(typeof(num)=='string'){
		num = num.trim()
		num = Number(num)
	}
	if(!num) {//不存在
		obj.bool = false
	}
	if(num.toString().indexOf('.')>-1) {//小数点
		obj.bool = false
	}
	if(num<30||num>250) {
		obj.bool = false
	}
	return obj

}

/**
 * 计划名字判断
 *
 */

window.nameBool = function(str) {
	let obj = {
		bool: true,
		cont: '计划名称的长度应在1-32个字符之间'
	}
	if(!str.trim()) {
		obj.bool = false
	}
	if(str.length>32) {
		obj.bool = false
	}
	return obj
}

/**
 * 每日预算判断
 */
window.dayBudgetBool = function(num,balance) {
	let obj = {
		bool: true,
		cont: '必须为大于等于 30.00 元，小于等于当前账户余额'
	}
	if(typeof(num)=='string'){
		num = num.trim()
		num = Number(num)
	}
	if(!num) {//不存在
		obj.bool = false
	}else if(num.toString().indexOf('.')>-1) {//小数点
		obj.bool = false
		obj.cont = "每日预算必须为整数"
	}else if(num<30||num>Number(balance)) {
		obj.bool = false
	}
	return obj
}

/**
 * 计划限价判定
 */
//验证宝贝限价
  window.verifyPlanLimitPrice = function(num) {  	let obj = {
  		bool: true,
  		cont: '请填写正确的限价'
  	}
    if(!num) {
      obj.bool = false
    }else if(!num.isPrice()) {
      obj.bool = false
      obj.cont = "请输入0.05~99.99之间的值，最多保留两位小数";
    }else if(num<0.05||num>99.99) {
    	obj.bool = false
      	obj.cont = "请输入0.05~99.99之间的值，最多保留两位小数";
    }
   	return obj
  }

/**
 * 淘宝的信息
 */
window.taobao = {
	state: 1212,//状态码
	clientId: "33770603",//淘宝客户端ID
	redirectUri: `${ONLINEURL}/login`,//淘宝回调地址	//淘宝登录地址
	loginUri: function(){
		return `https://oauth.taobao.com/authorize?response_type=code&client_id=${taobao.clientId}&redirect_uri=${taobao.redirectUri}&state=${taobao.state}&view=web`;
	},
  //升级版本地址
  upgradeUri: `'https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.8114210.1234-fwlb.4.259a5aca9uPvjJ&service_code=ts-13075&tracelog=search&from_key=%E6%B7%98%E5%93%81%E5%AE%9D'`,
	//购买软件地址
	buyerUri: function(){
		return "https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1001211030&code=FW_GOODS-1001211030&selected_item_code=FW_GOODS-1001211030";
	},
	//老版本地址
	beforeUri: function(){
		return `${BASEURL}/buyer/before`;
	}
}



// WEBPACK FOOTER //
// ./src/common/core.js